import { useContext } from 'react'
import { AppConfigContext, type AppConfigContextValue } from './context'

/**
 * アプリケーション設定を取得するhook
 */
export function useAppConfig(): AppConfigContextValue {
  return useContext(AppConfigContext)
}
